(() => {
  const config = document.getElementById('OaktSelfcareRewards');
  if (!config || config.dataset.currency !== 'CAD') return;
  const selector = '[id$="__oakt_selfcare_rewards"]';
  const currency = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
  const pattern = config.dataset.valuePattern;
  const mountedBlocks = new Map();
  let pending = false;
  function update() {
    pending = false;
    document.querySelectorAll(selector).forEach(candidate => {
      let block = candidate;
      const section = block.closest('.shopify-section');
      const key = section?.id;
      const mounted = mountedBlocks.get(key);
      if (key && mounted && mounted !== block && !mounted.isConnected) {
        block.replaceWith(mounted);
        block = mounted;
      }
      const paragraph = Array.from(block.querySelectorAll('p')).find(p => !p.closest('[data-oakt-reward-detail]') && /\bearn\s+[\d,\s]+\s+Selfcare Rewards\b/i.test(p.textContent));
      const match = paragraph?.textContent.match(/\bearn\s+([\d,\s]+)\s+Selfcare Rewards\b/i);
      const visible = paragraph && paragraph.getClientRects().length && getComputedStyle(paragraph).visibility !== 'hidden';
      if (!match || !visible) {
        block.querySelectorAll('[data-oakt-reward-detail], .oakt-selfcare-value').forEach(el => el.remove());
        block.removeAttribute('data-oakt-reward-enhanced');
        return;
      }
      const points = Number(match[1].replace(/[,\s]/g, ''));
      if (!Number.isFinite(points) || points < 0) return;
      if (key) mountedBlocks.set(key, block);
      const message = ' ' + pattern.replace('__AMOUNT__', currency.format(points / 100));
      let value = paragraph.querySelector('.oakt-selfcare-value');
      if (!value) {
        value = document.createElement('span');
        value.className = 'oakt-selfcare-value';
        paragraph.append(value);
      }
      if (value.textContent !== message) value.textContent = message;
      if (!block.querySelector('[data-oakt-reward-detail]')) block.append(config.content.cloneNode(true));
      if (!block.hasAttribute('data-oakt-reward-enhanced')) block.setAttribute('data-oakt-reward-enhanced', '');
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      if (target?.closest(selector)) return true;
      return Array.from(record.addedNodes).some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector)));
    });
    if (relevant) schedule();
  });
  observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['style','class','hidden']});
  document.addEventListener('shopify:section:load', schedule);
  update();
})();
